'use strict';
; (function () {
    angular.module("EMR.SelectMastectomyProcedurePopupModule", []);

    var SelectMastectomyProcedurePopupModuleRoutes = [
        {
            "state": false,
            "name": "emrSelectMastectomyProcedurePopup",
            "url": "emrSelectMastectomyProcedurePopup",
            "RoutingNumber": 4620,
            templateUrl: "AngularScripts/SelectMastectomyProcedure/Htmls/SelectMastectomyProcedurePopup.html",
            files: [
                "AngularScripts/EhrAgGridHandler/Factories/EhrAgGridHandlerFactory.js",
                "AngularScripts/SelectMastectomyProcedure/Services/SelectMastectomyProcedurePopupService.js",
                "AngularScripts/SelectMastectomyProcedure/Controllers/SelectMastectomyProcedurePopupController.js",
                
            ]
        },

    ]

    angular.module('EMR.SelectMastectomyProcedurePopupModule')
        .config(["$stateProvider", "EmrRouteProvider",
            function ($stateProvider, EmrRouteProvider) {
                EmrRouteProvider.registerStates(SelectMastectomyProcedurePopupModuleRoutes, $stateProvider);
            }]);
})();
